import { render, staticRenderFns } from "./FhMenuOperador.vue?vue&type=template&id=c4278e1c&scoped=true&"
import script from "./FhMenuOperador.vue?vue&type=script&lang=js&"
export * from "./FhMenuOperador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4278e1c",
  null
  
)

export default component.exports